import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import FiltersHeader from '../../components/filtersHeader';
import FilterList from '../../components/FilterList';

import { ModalFilter, Status as StatusInterface } from '../../types';
import { ReduxStates } from '../../redux/reduxTypes';
import MultiMetric from './components/MultiMetric';
import { formatDateFilter } from '../../helpers/format';
import Slicer from './components/Slicer';

const ScratchPad = (): React.ReactElement => {
  const filters = useSelector((state: ReduxStates) => state.filters);
  const savedFilters = useSelector((state: ReduxStates) => state.saved);
  const copyData = useSelector((state: ReduxStates) => state.copyData);
  const user = useSelector((state: ReduxStates) => state.user);
  const [status] = useState<StatusInterface[]>([]);
  const data = useSelector((state: ReduxStates) => state.data);
  const selectedCurrency = data.selectedCurrency;

  const [dateFilter, setDateFilter] = useState<string>(filters.dates.range || '');
  const [customRangeFilter, setCustomRangeFilter] = useState<Array<number | string> | null>(filters.dates?.custom);
  const [formattedDates, setFormattedDates] = useState<string>('');
  const [marketFilters, setMarketFilters] = useState<Array<ModalFilter | null>>(savedFilters.savedMarket);
  const [isSlicer, setIsSlicer] = useState<boolean>(false);

  const typeStyles = `cursor-pointer w-1/2 text-center m-0 box-border font-nunitoMedium h-full py-2 px-0 text-sm`;
  const history = useHistory();

  // set document title
  document.title = 'Scratchpad - Ascential Connect';

  //reroute if not in userModules
  useEffect(() => {
    if (user && user.userModules && !user.userModules.includes('Scratchpad')) history.push('/glance');
  }, [user]);

  //set market filters from filters state
  useEffect(() => {
    setMarketFilters(filters.market);
  }, [filters.market]);

  //format dates for data fetching
  useEffect(() => {
    if (copyData && data.dateFilterRangeLimit && !(dateFilter === 'Custom Range' && !filters.dates.custom)) {
      const formattedDateFilters = formatDateFilter(
        dateFilter,
        customRangeFilter || undefined,
        copyData,
        data.dateFilterRangeLimit
      );
      setFormattedDates(formattedDateFilters);
    }
  }, [dateFilter, customRangeFilter, copyData, data.dateFilterRangeLimit, filters.dates.custom]);

  return (
    copyData && (
      <div className="pt-[30px] px-6 pb-[43px] relative">
        {/* GLOBAL FILTERS */}
        <FiltersHeader
          marketFilters={marketFilters}
          status={status}
          dateFilter={dateFilter}
          customRangeFilter={customRangeFilter}
          setDateFilter={setDateFilter}
          setCustomRangeFilter={setCustomRangeFilter}
        />
        <div id="filters_breadcrumbs" className="w-full mt-3 mx-0 mb-5">
          <FilterList filters={marketFilters} />
        </div>

        <div className="w-full mt-3 mb-5"></div>

        <div className="bg-white rounded">
          <div className="box-border">
            <div className="p-[18px] border-b border-[#e1e1e1]">
              <div className="bg-[rgba(118,118,128,0.12)] rounded w-[236px] p-[3px]">
                <div className={`flex justify-between items-center h-full`}>
                  <p
                    role="button"
                    id="scratchpad_toggle-button_multimetric"
                    className={`${typeStyles} ${
                      !isSlicer &&
                      'bg-white text-navy border-[0.5px] border-[rgba(0,0,0,0.04)] shadow-scratchpadTypeShadow'
                    }`}
                    onClick={() => setIsSlicer(false)}
                  >
                    {copyData?.scratchpad_toggle_multimetric}
                  </p>
                  <p
                    role="button"
                    id="scratchpad_toggle-button_slicer"
                    className={`${typeStyles} ${
                      isSlicer &&
                      'bg-white text-navy border-[0.5px] border-[rgba(0,0,0,0.04)] shadow-scratchpadTypeShadow'
                    }`}
                    onClick={() => setIsSlicer(true)}
                  >
                    {copyData?.scratchpad_toggle_slicer}
                  </p>
                </div>
              </div>
            </div>

            {isSlicer ? (
              <Slicer
                marketFilters={marketFilters}
                formattedDates={formattedDates}
                selectedCurrency={selectedCurrency}
              />
            ) : (
              <MultiMetric
                marketFilters={marketFilters}
                formattedDates={formattedDates}
                selectedCurrency={selectedCurrency}
              />
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default ScratchPad;
